import '../../styles/messages.css'
import { FaceBot } from '../../Services/imagesRequest'

const BotAvatar = () => {
  return (
    <div className="bot-avatar" style={{ backgroundImage: `url(${FaceBot})` }}>
    </div>
  )
}

export default BotAvatar